// removed by extract-text-webpack-plugin
module.exports = {"headerBody":"w1Au9 _1-OXK _3_vf0 _1YmAR _2QXSI _1v96X","headerTextInput":"_1Potb _1bHiY Yioe5 _1RwNo _1Nil0","subheader":"RYaWw _3bI9n _28zmO","subheaderBody":"_1tx-0 _2QXSI","subheaderLink":"_2Qaqn","headerSchema":"_3B6fq _1lVIO _3rFJi"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/ReferenceHeader.css
// module id = 1187
// module chunks = 3